import { setUserInfo } from "@actions/profile";
import { Button, Col, Form, Row, Switch } from "antd";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ChangePasswordHeader, ChangePasswordWrapper } from "./elements";

const ChangePermission = ({ translate, setUserInfo, user }) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState(null);
	const username = user?.username;
	const [formTouched, setFormTouched] = useState(false);

	const save = (values) => {
		setUserInfo(
			username,
			{
				UserAttributes: [
					{
						Name: "accepts_sms",
						Value: values.accepts_sms ? "true" : "false",
					},
					{
						Name: "accepts_email",
						Value: values.accepts_email ? "true" : "false",
					},
				],
			},
			() => {
				form.resetFields();
			}
		);
	};

	useEffect(() => {
		if (user) {
			setInitialValues({
				accepts_sms: user.accepts_sms === true,
				accepts_email: user.accepts_email === true,
			});
		}
	}, [user]);
	return (
		<ChangePasswordWrapper>
			<ChangePasswordHeader>{translate("MANAGE_PERMISSIONS")}</ChangePasswordHeader>
			{initialValues && (
				<Form
					onFinish={save}
					initialValues={initialValues}>
					<Row
						xs={24}
						gutter={10}>
						<Col xs={12}>
							<Form.Item
								valuePropName="checked"
								className="switch-form-item"
								label={translate("ACCEPTS_SMS")}
								name="accepts_sms">
								<Switch onChange={() => setFormTouched(true)} />
							</Form.Item>
						</Col>
						<Col xs={12}>
							<Form.Item
								valuePropName="checked"
								className="switch-form-item"
								label={translate("ACCEPTS_EMAIL")}
								name="accepts_email">
								<Switch onChange={() => setFormTouched(true)} />
							</Form.Item>
						</Col>
					</Row>
					<Form.Item>
						<Button
							className="change-password-button"
							type="primary"
							disabled={!formTouched}
							style={{
								opacity: !formTouched ? "0.5" : "1",
							}}
							htmlType="submit">
							{translate("UPDATE_PERMISSIONS")}
						</Button>
					</Form.Item>
				</Form>
			)}
		</ChangePasswordWrapper>
	);
};

ChangePermission.propTypes = {
	translate: PropTypes.func.isRequired,
	setUserInfo: PropTypes.func.isRequired,
	user: PropTypes.object,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
	setUserInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePermission);
